import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ThankYou = ({ offline }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <div className="px-[20px] py-[10px]">
      <div className="flex flex-col gap-4">
        <div className="flex justify-center">
          <p className="text-[24px]">Thank you!</p>
        </div>
        {offline === 1 ? (
          <div className="flex flex-col gap-2">
            <p className="text-[12px] text-[#7A7A7A] font-normal">
              To make an offline donation toward the cause make a bank transfer
              to the account number below;
            </p>
            <div className="">
              <div className="flex gap-8">
                <p className="w-[95px] text-[#7A7A7A] text-[12px]">
                  Account Number:
                </p>
                <p className="italics text-[#7A7A7A] text-[12px] font-medium">
                  01928374651
                </p>
              </div>
              <div className="flex gap-8">
                <p className="w-[95px] text-[#7A7A7A] text-[12px]">
                  Account Name:
                </p>
                <p className="italics text-[#7A7A7A] text-[12px] font-medium">
                  Truekeepers
                </p>
              </div>
              <div className="flex gap-8">
                <p className="w-[95px] text-[#7A7A7A] text-[12px]">
                  Bank Name:
                </p>
                <p className="italics text-[#7A7A7A] text-[12px] font-medium">
                  True Bank
                </p>
              </div>
            </div>
          </div>
        ) : null}
        <div>
          <p className="text-[#7A7A7A] text-[12px]">
            Click on sign up to get feedback on how your donation made an
            impact. You can donate items or goods to this project by clicking on
            donate item.
          </p>
        </div>
        {!isAuthenticated && (
          <button
            onClick={() => navigate("/auth/donor/signup")}
            type="submit"
            className="bg-[#213874] text-white w-full p-2"
          >
            Sign up
          </button>
        )}

        <button
          onClick={() => navigate("/donate-items/category")}
          type="button"
          className="text-[#213874] bg-white p-2"
        >
          Donate Items
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
